import { LICENSES_CODE_TYPES } from './consts'

export interface LicenseType {
  activated: number
  beginsAt: null
  capabilities: LicenseCapability[]
  code: string
  created: number
  customerPO: null | string
  description: string
  domainId?: string
  domainName?: string
  enabled: boolean
  expiresAt: null | number
  homeId: string
  homeName: string | null
  homeRootDomainId?: string
  purchaserDomainId?: string
  hostId: string
  hostSerial: string
  hostUid: string
  id: number
  nalpeironImport: boolean
  name: string
  notes: string | null
  orderNumber: string
  price: number
  skuId: number
  skuNumber: string
  type: string
  updated: number
}

interface LicenseCapability {
  code: string
  count?: number
  id: number
  name: string
  type: string
}

export enum LICENSES_IMPORT_FILTERS {
  transferred = 'Transferred',
  rma = 'RMA',
}

export interface LicensesCollapseStateActionPayload {
  showAvailableCodes: boolean
  groupName: string
}

export interface LicenesCollapseState {
  [LICENSES_CODE_TYPES.available]: string[]
  [LICENSES_CODE_TYPES.used]: string[]
}
